// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__13xrA","title":"Header_title__19kGJ","left":"Header_left__b4tbb","clinicName":"Header_clinicName__1KeAr"};